import { ownerDocument } from './ownerDocument.js';

export const ownerWindow = (node: Node | undefined): Window => {
  const doc = ownerDocument(node);
  return doc.defaultView || window;
};
